import styled from "styled-components"

export const StyledHero = styled.div`
  width: 100%;
  height: 100vh;
  max-height: 768px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  background: red;
  margin-top: -121px;

  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    margin-top: -99px;
  }
`

export const StyledHeroContainer = styled.div`
  ${(props) => props.theme.mixins.container};
  position: relative;
  display: flex;
  height: 100%;
  align-items: center;
  position: absolute;
  top: 0;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
`

export const StyledBgImg = styled.div`
  background: purple;
  width: 100%;
  height: 100%;

  & > div {
    height: 100%;
  }

  & img {
    width: 100%;
  }
`
export const StyledHeroContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 33px;
  padding-top: 10%;

  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    padding-top: 20%;
  }
`
export const StyledHeader = styled.div`
  max-width: 420px;
  height: 100%;

  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    max-width: 398px;
  }

  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    max-width: 202px;
  }
`

export const StyledTitle = styled.div`
  ${(props) => props.theme.mixins.h1};
  font-size: 64px;
  line-height: 68px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 48px;
    line-height: 52px;
  }

  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    font-size: 32px;
    line-height: 36px;
  }
`

export const StyledDesc = styled.div`
  ${(props) => props.theme.mixins.body};
  font-size: 18px;
  padding: 24px 0;
  color: ${(props) => props.theme.colors.black};

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
  }
`

export const StyledHeroButtons = styled.div`
  & .button-v2--secondary {
    border: none;

    @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
      display: inline-flex;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      min-height: 51px;
      font-size: 14px;

      & svg {
        max-height: 14px;
        max-width: 14px;
      }
    }
  }
`

export const StyledShape = styled.div`
  position: absolute;
  top: calc(100% - 188px);
  left: -40px;
  & img {
    width: 100%;
  }

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    left: -80px;

    & img {
      width: 80%;
    }
  }

  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    top: calc(100% - 108px);
  }
`
